import { render, staticRenderFns } from "./SectionAdmin.vue?vue&type=template&id=7c10759b&scoped=true&"
import script from "./SectionAdmin.vue?vue&type=script&lang=js&"
export * from "./SectionAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c10759b",
  null
  
)

export default component.exports